const isArray = require('lodash/isArray')
const mergeWith = require('lodash/mergeWith')
const castArray = require('lodash/castArray')

/**
 * Merges multiple filter objects into one, combining their properties and arrays using a customizer function.
 * @param {Object} filterObjects - An object containing filter objects to merge.
 * @returns {Object} - The merged filter object.
*/
exports.mergeFilterObjects = function (filter1, filter2) {
  function customizer (objValue, srcValue) {
    if (srcValue && typeof objValue === 'undefined') {
      return srcValue
    } else if (objValue && typeof srcValue === 'undefined') {
      return objValue
    } else if (
      (isArray(objValue) && srcValue) ||
      (isArray(srcValue) && objValue)
    ) {
      // CRITICAL: Empty arrays represent "match nothing" filters (e.g., route_id: [] for drivers with no routes)
      // If either array is empty, preserve the empty array behavior - don't concatenate
      // This ensures drivers with no routes see zero shipments and can't bypass restrictions
      if (isArray(objValue) && objValue.length === 0) {
        return objValue // Preserve empty array from filter1 (user filters) - security: no routes = no shipments
      }
      if (isArray(srcValue) && srcValue.length === 0) {
        return srcValue // Preserve empty array from filter2 (default filters) - security: no routes = no shipments
      }
      // Both arrays are non-empty, concatenate them (normal merge behavior)
      return castArray(objValue).concat(castArray(srcValue))
    } else {
      return [srcValue, objValue]
    }
  }

  return mergeWith(filter1, filter2, customizer)
}

/*
* Filters an array of locations based on a program ID. Gets locations assigned to given program
*
* @param {Array} locations - The array of locations to filter.
* @param {string} programId - The ID of the program to filter by.
* @returns {Array} - Returns the filtered array of locations.
*/
exports.filterLocationsByProgram = function (locations, programId) {
  return locations.filter(location => locationHasProgram(location, programId))
}

function locationHasProgram (location, programId) {
  return location.programs
    .some((program) => (program.id === programId && program.services && program.services.length))
}
